<div>
  <div
    class="border-b border-primary bg-white flex justify-between items-center mb-6 pb-2"
  >
    <img src="assets/images/new-images/logo-2.png" class="w-[6rem] h-[2rem]" />

    <h2 class="font-semibold text-xl text-center">
      <span *ngIf="data?.isEdit" i18n="@@editPaymentGatewayTitle"
        >Edit Payment Gateway</span
      >
      <span *ngIf="!data?.isEdit" i18n="@@newPaymentGatewayTitle"
        >New Payment Gateway</span
      >
    </h2>

    <div class="flex gap-4">
      <mat-icon class="text-red-500 text-3xl cursor-pointer" (click)="cancel()"
        >highlight_off</mat-icon
      >
    </div>
  </div>

  <mat-dialog-content class="flex flex-col gap-6">
    <form [formGroup]="gatewayForm">
      <!-- Name & Logo Row -->
      <div class="flex flex-col md:flex-row gap-4">
        <!-- Contact Info -->
        <div class="w-full flex flex-col gap-4">
          <div class="flex flex-col md:flex-row gap-4">
            <!-- Show readonly input for edit mode, dropdown for new mode -->
            <mat-form-field
              appearance="outline"
              class="w-full"
              *ngIf="!data?.isEdit"
            >
              <mat-label i18n="@@selectPaymentGatewayLabel"
                >Select Payment Gateway</mat-label
              >
              <mat-select formControlName="paymentProvider" required>
                <mat-option
                  *ngFor="let gateway of availableGateways"
                  [value]="gateway.gatewayId"
                >
                  {{ gateway.gatewayName }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="gatewayForm.get('paymentProvider')?.hasError('required')"
                class="text-xs pb-2"
                i18n="@@selectPaymentGatewayError"
              >
                Please select a payment gateway
              </mat-error>
            </mat-form-field>

            <!-- Readonly input for edit mode -->
            <mat-form-field
              appearance="outline"
              class="w-full"
              *ngIf="data?.isEdit"
            >
              <mat-label i18n="@@paymentGatewayLabel"
                >Payment Gateway</mat-label
              >
              <input matInput readonly [value]="getSelectedGatewayName()" />
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              *ngIf="gatewayForm.get('paymentProvider')?.value === 0"
            >
              <mat-label i18n="@@paymentGatewayNameLabel"
                >Payment Gateway Name</mat-label
              >
              <input
                matInput
                formControlName="otherPaymentGatewayName"
                required
              />
              <mat-error
                *ngIf="
                  gatewayForm
                    .get('otherPaymentGatewayName')
                    ?.hasError('required')
                "
                class="text-xs pb-2"
                i18n="@@paymentGatewayNameError"
              >
                Payment Gateway Name is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col md:flex-row gap-4">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@contactNameLabel">Contact Name</mat-label>
              <input matInput formControlName="contactName" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
              <mat-label i18n="@@contactEmailLabel">Contact Email</mat-label>
              <input matInput formControlName="contactEmail" type="email" />
            </mat-form-field>
          </div>

          <mat-checkbox
            formControlName="isDefault"
            class="pt-2"
            [disabled]="gatewayForm.get('paymentProvider')?.value === 0"
            i18n="@@setAsDefaultCheckbox"
          >
            Set as default gateway
          </mat-checkbox>
        </div>

        <div class="flex justify-end">
          <app-file-upload-ui
            [disabled]="false"
            [acceptPdf]="false"
            [label]="'Logo *'"
            i18n-label="@@logoLabelRequired"
            classNames="!w-[100%] h-[85px] cursor-pointer"
            [currentPhoto]="logoPreview"
            [editing]="true"
            (upload)="onFileChange($event, 'uploadLogo')"
            (removeFile)="
              gatewayForm.get('uploadLogo')?.setValue('');
              logoPreview = null;
              logoFile = null
            "
          >
          </app-file-upload-ui>
        </div>
      </div>

      <!-- Credentials -->
      <div formArrayName="credentials" class="mt-7">
        <h3
          class="text-lg font-medium text-gray-700 mb-3"
          i18n="@@credentialsTitle"
        >
          Credentials
        </h3>

        <div
          *ngFor="let cred of credentialControls; let i = index"
          [formGroupName]="i"
          class="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          <mat-form-field
            appearance="outline"
            [class.readonly]="shouldCredentialNameBeReadonly(i)"
          >
            <mat-label i18n="@@credentialNameLabel">Credential Name</mat-label>
            <input
              matInput
              formControlName="name"
              [readonly]="shouldCredentialNameBeReadonly(i)"
            />
          </mat-form-field>

          <div class="flex items-center gap-2 w-full">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label i18n="@@credentialDetailsLabel"
                >Credential Details</mat-label
              >
              <input matInput formControlName="value" />
            </mat-form-field>
            <button
              mat-icon-button
              matSuffix
              (click)="removeCredential(i)"
              *ngIf="
                credentials.length > 1 && (isNewCredential(i) || data?.isEdit)
              "
            >
              <span class="material-symbols-rounded text-[16px] text-red-500"
                >delete</span
              >
            </button>
          </div>
        </div>

        <div class="flex justify-end">
          <app-button-icon-ui
            value="new_credential"
            name="New Credential"
            i18n-name="@@newCredentialButton"
            icon="add"
            (click)="addCredential()"
            classNames="bg-white border border-primary text-primary px-2 py-1 rounded-lg flex items-center gap-2"
          >
          </app-button-icon-ui>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="flex justify-center mb-4">
    <button
      type="button"
      (click)="save()"
      [disabled]="!isValid()"
      class="bg-primary text-white px-6 py-2 rounded-md flex items-center disabled:opacity-50 disabled:cursor-not-allowed hover:bg-primary/90 transition-all duration-200"
      i18n="@@saveButton"
    >
      Save
    </button>
  </mat-dialog-actions>
</div>
